import { render, staticRenderFns } from "./ImageResizer.vue?vue&type=template&id=1c6d2a80&scoped=true"
import script from "./ImageResizer.vue?vue&type=script&lang=js"
export * from "./ImageResizer.vue?vue&type=script&lang=js"
import style0 from "./ImageResizer.vue?vue&type=style&index=0&id=1c6d2a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6d2a80",
  null
  
)

export default component.exports